import { BigNumber } from 'ethers';
import { formatEther, formatUnits, parseEther, parseUnits } from 'ethers/lib/utils';
import { RemoveMarginFromPositionParamsStruct } from '../../config/contracts/typechain/ITradeManager';

const generateWithdrawPositionLog = (
    margin: string,
    volume: string,
    userFee: BigNumber,
    decimals: number,
    params: RemoveMarginFromPositionParamsStruct
) => {
    const newMargin = formatUnits(
        parseUnits(margin, decimals).sub(params.removedMargin.toString()),
        decimals
    );

    const newLeverage = formatEther(
        parseEther(volume).mul(parseEther('1')).div(parseEther(newMargin))
    );

    const fees = formatEther(
        parseEther(formatUnits(params.removedMargin.toString(), decimals))
            .mul(userFee)
            .div(100_00)
    );

    return { newMargin, newLeverage, fees };
};

export default generateWithdrawPositionLog;
